import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialogRef } from '@angular/material/dialog';
import { PayoutDialog } from '@components/payout.dialog';
import { environment } from '@environments/environment';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'withdraw-paypal-b3000-component',
  templateUrl: './withdraw-paypal-b3000.component.html',
})
export class WithdrawPaypalB3000Component implements OnInit {
  coinbaseWithdrawDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  MinValue: any;
  MaxValue: any;
  @Output() dataChangedCallback = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<WithdrawPaypalB3000Component>,
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.route.params.subscribe(params => {
      this.getWithDrawInfo();
    });

    this.coinbaseWithdrawDatas = _FormBuilder.group({
      withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(50), Validators.maxLength(10)]),
      paypaladdress: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {
    console.warn('data', this.data.amount);
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Paypal', true);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getWithDrawInfo() {
    this._ApiService.getWithDrawDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const WithDrawInfo = result;

      this.MinValue = WithDrawInfo[0].MinValue;
      this.MaxValue = WithDrawInfo[0].MaxValue;
      if (WithDrawInfo.length > 0) {
        if (this.data.amount) {
          this.coinbaseWithdrawDatas.controls.withdrawamount.setValue(this.data.amount);
        } else {
          this.coinbaseWithdrawDatas.controls.withdrawamount.setValue('');
        }
        // this.coinbaseWithdrawDatas = this._FormBuilder.group({

        //   withdrawamount: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(this.MinValue), Validators.max(this.MaxValue)]),
        //   paypaladdress: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.email])

        // });

        this.coinbaseWithdrawDatas.valueChanges.subscribe(x => {
          this.coinbaseDataRaw = x;
        });
        this.dataChangedCallback.emit(true);
      }
    });
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  submitCoinbaseWithdrawData() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.withdrawPaypal(this.coinbaseDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      ////console.log("COIN_BASE_WITHDRAW", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          this.openPayoutDialog();

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');

          this.coinbaseWithdrawDatas.patchValue({ withdrawamount: '' });

          this._ApiService
            .getClient()
            .then(t => {
              this._UserHelper.updateUser(t);
            })
            .catch();
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
